<template>
  <div class="reset-pass">
    <div class="reset-title">
      <div :class="[{ 'reseta': nowIndex == 1 },{ 'resetb': nowIndex == 2 }, 'reset1']"></div>
      <div :class="[{ 'resetc': nowIndex == 1 },{ 'resetd': nowIndex == 2 }, 'reset2']"></div>
      <div class="reset3" :class="{'resete':nowIndex == 2}"></div>
    </div>
    <div class="reset-first" @keydown.enter='getMobile' v-if='nowIndex == 0'>
      <div class="reset-tel">
        <input maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')" v-model='mobile' placeholder='请输入手机号' type="text" />
      </div>
      <p class="reset-wrong"></p>
      <button class="reset-button" @click="getMobile">下一步</button>
    </div>
    <div class="reset-second" @keydown.enter='changePassWord' v-if='nowIndex == 1'>
      <p class="send-confirm">验证码将发送到 <span>{{mobile}}</span></p>
      <div class="r-confirm">
        <div class="r-confirm-left">
          <input v-model='code' placeholder='请输入验证码' type="text" />
        </div>
        <button :disabled="disabled" class="r-get-confirm" @click="getCode">{{time}}</button>
      </div>
      <div class="r-r-password">
        <input v-model='passwd' placeholder='请输入密码' type="password" />
      </div>
      <p class="r-reset-wrong"></p>
      <button class="reset-button1" @click="changePassWord">下一步</button>
    </div>
    <div class="reset-three" @keydown.enter='gotoLogin' v-if='nowIndex == 2'>
      <div class="reset-succeed"></div>
      <button class="reset-login" @click="gotoLogin">重新登录</button>
    </div>
  </div>
</template>
<script type="text/javascript">
  import { apiUrl } from '../apiUrl.js'
  import { eventBus } from '../eventBus.js'
  export default {
    data() {
      return {
        mobile: '',
        nowIndex: 0,
        code: '',//注册验证码
        passwd: '',//注册密码
        disabled: false,
        count: 60,
        time: '获取验证码',
        timer: null
      }
    },
    methods: {
      getMobile() {
        var phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if(!phoneReg.test(this.mobile)) {
          this.$message.error('请输入正确的手机号码！')
        }else {
          this.nowIndex = 1
        }
      },
      getCode() {
        var checkMoblieUrl = apiUrl + 'api/sms/checkMoblie?mobile=' + this.mobile + '&uid=0' + '&type=1'
         this.axios.post(checkMoblieUrl)
        .then((res) => {
          if(res.data.code == 200) {
            this.disabled = true
            this.count = 60
            this.time = this.count + 'S'
            this.timer = setInterval(() => {
              this.count--
              this.time = this.count + 'S'
              if(this.count == 0) {
                clearInterval(this.timer)
                this.count = 60
                this.disabled = false
                this.time = '重新获取验证码'
              }
            },1000)
          }else {
            this.$message.error(res.data.msg);
          }
        })
      },
      changePassWord() {
        if(!this.code) {
          this.$message.error('请输入验证码！')
        }else if(this.passwd.length < 6 || this.passwd.length > 20) {
          this.$message.error("密码为6-20位!");
        }else {
          var forgetPasswordUrl = apiUrl + 'api/User/forgetPassword?mobile=' + this.mobile + '&passwd=' + this.passwd + '&code=' + this.code + '&passwd2=' + this.passwd
          this.axios.post(forgetPasswordUrl)
          .then((res) => {
            if(res.data.code == 200) {
              this.nowIndex = 2
            }else {
              this.$message.error(res.data.msg)
            }
          })
        }
      },
      gotoLogin() {
        eventBus.$emit('goto-login')
      }
    }
  }
</script>
<style scoped>
  .reset-pass {
    padding-bottom: 76px;
    width: 1200px;
    padding-top: 40px;
    border-radius: 20px;
    background: #fff;
  }
  .reset-title {
    width: 1066px;
    height: 42px;
    margin: 0 auto;
  }
  .reset1,.reset2 {
    float: left;
    width: 346px;
    height: 42px;
    cursor: pointer;
    margin-right: 21px;
    background: url(../assets/22.png) 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .reset2 {
    background-image: url(../assets/23.png);
  }
  .reset3 {
    float: left;
    width: 332px;
    height: 42px;
    cursor: pointer;
    background: url(../assets/24.png) 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .reseta {
    background-image: url(../assets/70.png);
  }
  .resetb {
    background-image: url(../assets/67.png);
  }
  .resetc {
    background-image: url(../assets/71.png);
  }
  .resetd {
    background-image: url(../assets/68.png);
  }
  .resete {
    background-image: url(../assets/69.png);
  }
  .reset-tel {
    width: 332px;
    height: 42px;
    margin: 124px auto 0;
  }
  .reset-tel input {
    display: block;
    width: 282px;
    height: 40px;
    padding-left: 48px;
    border: none;
    outline: none;
    font-size: 14px;
    line-height: 40px;
    color: #333;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    background: url(../assets/19.png) 20px center no-repeat;
    background-size: 17px 20px;
  }
  .reset-wrong,.r-reset-wrong,.wrong {
    height: 40px;
    width: 332px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    color: #f000f0;
  }
  .reset-button,.reset-button1 {
    display: block;
    width: 332px;
    height: 40px;
    margin: 0 auto;
    padding: 0;
    border: none;
    outline: none;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #40c0c0;
    border-radius: 5px;
  }
  .reset-second {
    width: 332px;
    margin: 0 auto;
  }
  .send-confirm {
    height: 16px;
    margin: 28px 0 18px;
    font-size: 16px;
    line-height: 16px;
    color: #777777;
  }
  .r-confirm {
    width: 332px;
    height: 42px;
    margin-bottom: 16px;
  }
  .r-confirm-left {
    float: left;
  }
  .r-confirm-left input {
    width: 113px;
    padding-left: 51px;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    border: none;
    outline: none;
    color: #333;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    background: url(../assets/21.png) 20px center no-repeat;
    background-size: 17px 21px;
  }
  .r-get-confirm {
    float: right;
    display: block;
    width: 136px;
    height: 42px;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    line-height: 42px;
    text-align: center;
    color: #fff;
    background: #40c0c0;
    border: none;
    outline: none;
    border-radius: 3px;
  }
  .r-r-password input {
    display: block;
    width: 282px;
    height: 40px;
    padding-left: 48px;
    border: none;
    outline: none;
    font-size: 14px;
    line-height: 40px;
    color: #333;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    background: url(../assets/19.png) 20px center no-repeat;
    background-size: 17px 20px;
  }
  .send-confirm span {
    color: #40c0c0;
    font-size: 16px;
  }
  .reset-succeed {
    width: 346px;
    height: 206px;
    margin: 0 auto;
    background: url(../assets/25.png) 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .reset-login {
    display: block;
    width: 128px;
    height: 40px;
    margin: 0 auto;
    padding: 0;
    font-size: 16px;
    line-height: 40px;
    border: none;
    outline: none;
    cursor: pointer;
    text-align: center;
    color: #fff;
    background: #40c0c0;
    border-radius: 3px;
  }
  input:hover {
    border-color: #40c0c0;
  }
  input[type="text"]:focus, 
  input[type="password"]:focus { 
    border-color: #40c0c0;
  }
</style>


// WEBPACK FOOTER //
// src/components/reset.vue